<template>
  <div class="Calllist">
    <div class="topBar">
      <div class="subTitle">
        <i class="far fa-window-minimize" style="transform:rotate(90deg);margin-right:-10px;color:rgba(52,152,219,1);"></i>
        订单列表
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>

    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">筛选查询</div>
      </div>
      <div style="background-color:#fff;">
        <el-row class="search" :gutter="10">
          <el-col :span="2">
            <div class="label">输入搜索:</div>
          </el-col>
          <el-col :span="4">
            <el-input v-model="number" clearable size="small" placeholder="姓名"></el-input>
          </el-col>
          <el-col :span="2">
            <div class="label">电话:</div>
          </el-col>
          <el-col :span="4">
            <el-input v-model="name" clearable size="small" placeholder="电话"></el-input>
          </el-col>
          <el-col :span="2">
            <div class="label">提交时间:</div>
          </el-col>
          <el-col :span="4">
            <template>
              <div class="block">
                <el-date-picker v-model="value1" size="small" clearable placeholder="选择日期时间"></el-date-picker>
              </div>
            </template>
          </el-col>
          <el-col :span="6" align="center">
            <div class="filtrate_seek_sousuo" @click="geting()">搜索</div>
          </el-col>
        </el-row>
      </div>

      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table :data="tableData" border style="width: 100%" ref="multipleTable">
        <!-- <el-table-column label width="40" v-model="select" type="selection"></el-table-column> -->
        <el-table-column prop="nickname"  label="姓名" align="center"></el-table-column>

        <el-table-column prop="bind_mobile" width="160" label="电话" align="center"></el-table-column>
        <el-table-column prop="create_time" width="200" label="提交时间" align="center"></el-table-column>
        <el-table-column prop="all_money" label="订单金额" align="center"></el-table-column>
        <el-table-column prop="pay_type" label="支付方式" align="center"></el-table-column>
        <el-table-column prop="status" label="订单状态" align="center"></el-table-column>
        <el-table-column label="操作" width="200" align="center" name="bianji">
          <template slot-scope="scope" style="display:flex;padding:0;margin:0">
            <router-link tag="button" class="button1" :to="'./d_viewOrde/'+ scope.row.id + '/' + 3 ">
             查看订单
            </router-link>
            <button
              @click="del(scope.row.id,scope.row.status1,scope.row.orderCode), shipments(scope.row.id)"
              class="button1"
            >{{scope.row.status1}}</button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager">
        <el-row>
          <el-col :span="8" style="padding-left:10px;">
            <!-- <el-checkbox v-model="selectAll" style="line-height: 34px">全选</el-checkbox> -->
          </el-col>
          <el-col :span="14">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="15"
              @current-change="setPage"
            >1</el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>
    <noAccess v-else></noAccess>
    <!-- 点击确认发货 -->
    <el-dialog title="确认发货" :visible.sync="dialogFormVisible1" width="33%">
      <el-form>
        <el-form-item label="物流公司:">
          <template>
            <el-select v-model="value" placeholder="全部">
              <el-option
                v-for="item in option"
                :key="item.id"
                :label="item.com_name"
                :value="item.id"
              ></el-option>
            </el-select>
          </template>
        </el-form-item>
        <el-form-item label="物流单号:">
          <el-input style="width:356px" v-model="odd" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible1 = false,submit()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 确认采购 -->
    <el-dialog title="确认采购" :visible.sync="dialogFormVisible2" width="33%">
      <el-form>
        <el-form-item label="订单编号:">
          <el-input style="width:356px" v-model="order" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="订单货期:">
          <el-input
            style="width:356px"
            placeholder="请输入期限/单位为天"
            v-model="order_date"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="submit1()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "list",
  data() {
    return { serve: this.$store.state.serve,
      order: "",
      order_date: "",
      id: "",
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      number: "",
      name: "",
      value1: "",
      token: "",
      username: "",
      page: null,
      total: 0,
      resType: null,
      option: [],
      value: "",
      odd: "",
      msg: "",
      role: true,
      count0: 0,
      count1: 0, //未付款
      count2: 0, //待采购
      count3: 0, //待发货
      count4: 0, //已发货
      count5: 0, //待评价
      count6: 0, //已完成
      count7: 0, //取消
      name: null,
      category: null,
      categorys: [],
      brand: null,
      brands: [],
      tableData: [],
      multipleSelection: [],
      isIndeterminate: true,
      select: false,
      selectAll: false,
      checked: [],
      idString: "",
      msg1:'',
    };
  },
  created() {
    this.$store.state.topActiveId = 3;
    this.$store.state.leftTitle = "取消订单";
    this.geting();
   
  },
  watch: {
    //监听全选状态
    selectAll(v) {
      if (v == false) {
        this.$refs.multipleTable.clearSelection();
      } else {
        this.$refs.multipleTable.clearSelection();
        this.$refs.multipleTable.toggleAllSelection();
      }
    }
  },
  methods: {
    shipments(id) {
      //确认发货弹窗
      const _this = this;
      this.axios
        .get(this.serve+"/admin/get_express_list", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          _this.option = [];
          var json = res.data.data.results;
          _this.id = id;
          for (var key in json) {
            if (json[key].status == "1") {
              _this.option.push(json[key]);
            }
          }
        });
    },
    open4() {
      //错误时返回的息状态
      this.$message.error(this.msg1);
    },
    open() {
      this.$message({
        //成功时 返回的状态
        message: "发货成功",
        type: "success"
      });
    },
    submit(id) {
      //确认发货弹窗提交
      const _this = this;
      this.axios
        .get(this.serve+"/admin/shipments", {
          params: {
            username: this.username,
            token: this.token,
            order_id: this.id,
            express_com: this.value,
            express_code: this.odd
          }
        })
        .then(res => {
        
          this.msg1 = res.data.msg
          if (res.data.status == "success") {
            _this.open();
            _this.geting();
            _this.heading();
          } else if (res.data.status == "error") {
            _this.open4();
          }
        });
    },
    red(id) {
      this.$router.push("d_viewOrde?id=" + id);
    },
    del(id, status1, orderCode) {
      if (status1 == "确认发货") {
        this.dialogFormVisible1 = true;
      }
      if (status1 == "提醒付款") {
        this.payment(orderCode);
      }
      if (status1 == "确认采购") {
        this.dialogFormVisible2 = true;
        this.order = orderCode;
      }
      if (status1 == "订单跟踪") {
        this.$router.push({
          path: "d_orderTail/" + id
        });
      }
    },
    submit1() {
      this.axios
        .get(this.serve+"/admin/buy_product", {
          params: {
            username: this.username,
            token: this.token,
            orderCode: this.order,
            order_date: this.order_date
          }
        })
        .then(res => {
          if ((res.data.status = "success")) {
            this.dialogFormVisible2 = false;
            this.geting();
            this.heading();
            this.$message({
              type: "success",
              message: "采购成功!"
            });
          }
        });
    },
    payment(orderCode) {
      //提醒付款
      this.$confirm("此操作将提醒付款, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .get(this.serve+"/admin/warn_user_pay", {
              params: {
                username: this.username,
                token: this.token,
                orderCode
              }
            })
            .then(res => {
              this.msg = res.data.msg;
              if (res.data.status == "success") {
                this.geting();
                this.heading();
                this.$message({
                  type: "success",
                  message: "提醒成功!"
                });
              } else if (res.data.status == "error") {
                this.$message.error(this.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    setType(type) {
      //点击分类 订单
      this.resType = type;
      this.geting();
    },
    setPage(v) {
      //分页
      this.page = v;
      this.geting(v);
      this.selectAll = false;
    },
  
    geting(page) {
      //请求数据
      var that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve+"/admin/order_list", {
          params: {
            page: page,
            token: this.token,
            username: this.username,
            orderCode: this.number,
            mobile: this.name,
            create_time: this.value1,
            status: 6
          }
        })
        .then(res => {
          that.tableData = [];
          var json = res.data.data;
         
          if (res.data.status == "success") {
            
            that.total = res.data.data.total;
            //  that.current_page =res.data.data.now_page;
            that.page = res.data.data.now_page;
            var count = res.data.data;

            for (var key in json.results) {
              json.results[key].all_money = json.results[key].all_money + "￥";
              if (json.results[key].status == 0) {
                json.results[key].status = "待付款";
                json.results[key].status1 = "提醒付款";
              } else if (json.results[key].status == 1) {
                json.results[key].status = "待采购";
                json.results[key].status1 = "确认采购";
              } else if (json.results[key].status == 2) {
                json.results[key].status = "待发货";
                json.results[key].status1 = "确认发货";
              } else if (json.results[key].status == 3) {
                json.results[key].status = "待收货";
                json.results[key].status1 = "订单跟踪";
              } else if (json.results[key].status == 4) {
                json.results[key].status = "待评价";
              } else if (json.results[key].status == 5) {
                json.results[key].status = "已完成";
              } else if (json.results[key].status == 6) {
                json.results[key].status = "已取消";
              }
              var time = json.results[key].create_time;
              var timeNew = new Date(parseInt(time) * 1000)
                .toLocaleString()
                .replace(/:\d{1,2}$/, " ");
              json.results[key].create_time = timeNew;
              that.tableData.push(json.results[key]);
              if(json.results[key].pay_type == 1){
                json.results[key].pay_type = '在线支付'
              }else if(json.results[key].pay_type ==  2){
                json.results[key].pay_type = '货到付款'
              }
            }
          } else {

            if(res.data.code == '403'){
              that.role = false;
            }
            // this.tableData = [];
            // this.total = 0
            // this.now_page = 1
          }
        });
    }
  }
};
</script>
<style lang="scss">
.Calllist {
  background: #f5f5f5;

  color: #333;
  min-height: 1000px;
  padding-bottom: 100px;
  .topBar {
    margin-bottom: 40px;
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu1 {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      margin-right: 0;
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>